export default __webpack_public_path__ + "static/media/segre19.d614791d.jpg";